// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notifications_notificationMainContainer__W-Kto {
  /* width: 100%; */
}

.notifications_filterdropdown__vR28z {
  display: flex;
  justify-content: space-between;
}
.notifications_filterdropdown__vR28z h5 {
  color: #000000;
  font-size: 18px;
  margin-top: 10px;
  margin-left: 10px;
}
.notifications_selectpulldown__YoM9G {
  border: none;
  border-radius: 10px;
  background-color: #f3f2f0;
  font-size: 15px;
  width: 125px;
  height: 25px;
  padding: 0px 10px;
  margin: 10px 0 0 0;
  box-shadow: 0px 3px 6px #00000029;
  color: #000000;
  cursor: pointer;
}

.notifications_selectpulldown__YoM9G option {
  color: #373334;
  font-size: 13px;
  padding: 8px 13px;
  font-weight: 300;
  cursor: pointer;
}

/* .selectpulldown:after {
    content: " ";
    width: 15px;
    height: 15px;
    position: absolute;
    z-index: 11;
    right: 10px;
    top: 5px;
    background: url(../../images/pulldown.svg) center no-repeat;
  } */
.notifications_recentTitle__7Bl3W,
.notifications_earlierTitle__TebVo {
  color: #373334;
  font-size: 14px;
  margin: 0 0 0 10px;
}
.notifications_notificationPost__23kgq{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  gap: 5px;
}
.notifications_notificationbody__RRsVT {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  background: #f3f2f0;
  border-radius: 25px;
  padding: 7px 12px 12px 15px;
  margin: 10px 0px;
  justify-content: space-between;
}
.notifications_notificationmessagebody__uJQsK > div > p {
  margin-bottom: 0px;
}
.notifications_avatarimage__dx0fw {
  margin: 9px 10px 0px 0px;
}
.notifications_loader__QRAQm {
  position: absolute;
  top: 40%;
  left: 46%;
}
.notifications_tagcount__0N2l- {
  position: relative;
  left: 33px;
  bottom: 7px;
  background-color: #efba29;
  width: 10px;
  height: 10px;
  color: white;
  font-size: 10px;
  border-radius: 50%;
  padding: 0 0 0 4.4px;
}
.notifications_updatecount__s4VXc {
  position: relative;
  left: 33px;
  bottom: 7px;
  background-color: #e82727;
  width: 10px;
  height: 10px;
  color: white;
  font-size: 10px;
  border-radius: 50%;
  padding: 0 0 0 4.4px;
}
.notifications_saycount__1vELr {
  position: relative;
  left: 33px;
  bottom: 7px;
  background-color: #45a735;

  width: 10px;
  height: 10px;
  color: white;
  font-size: 10px;
  border-radius: 50%;
  padding: 0 0 0 4.4px;
}
.notifications_askcount__8qPXG {
  position: relative;
  left: 33px;
  bottom: 7px;
  background-color: #2168b2;

  width: 10px;
  height: 10px;
  color: white;
  font-size: 10px;
  border-radius: 50%;
  padding: 0 0 0 4.4px;
}
.notifications_notificationdropdown__yDbu9 {
  outline: none !important;
  background-color: transparent;
  /* color: white !; */
  /* padding: 16px; */
  font-size: 16px;
  border: none !important;
  cursor: pointer;
  /* background: lightgray; */
  float: right;
}
.notifications_notificationdropdownlinks__Yyxxv > ul {
  margin-bottom: 0;
  font-size: 14px;
  list-style-type: none;
  color: black;
  padding: 5px 0px 0px 5px;
}
.notifications_notificationdropdownlinks__Yyxxv {
  border: none;
  padding: 10px 10px 5px 10px;
  min-width: 200px;
  border-radius: 25px;
  top: 20px;
}
.notifications_notificationdropdownlinks__Yyxxv > ul > li > a > span {
  padding-left: 7px;
}
.notifications_notificationdropdownlinks__Yyxxv ul li {
  margin-bottom: 8px;
}

.notifications_earlierTitle__TebVo {
  margin-top: 20px;
}
/* .message{
      font-size: 14px;
  } */
.notifications_messagetime__n4SSJ {
  font-size: 12px;
  font-weight: 100;
  margin-left: 10px;
  color: rgba(0, 0, 0, 0.7);
}
.notifications_notificationmessagebody__uJQsK {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  overflow-wrap: anywhere; /* Allow breaking at any character if needed */
  word-wrap: break-word;
  white-space: normal;
  flex-shrink: 1;
  min-width: 0;
  flex-basis: auto; /* Allow it to adjust size based on content */
}
.notifications_mesageandtime__nrgcK {
  overflow-wrap: anywhere; /* Allow breaking at any character if needed */
  word-wrap: break-word;
  white-space: normal;
  flex-shrink: 1;
  min-width: 0;
  flex-basis: auto; /* Allow it to adjust size based on content */
}
.notifications_msgTxt__4kr0L {
  word-break: break-word; /* Works better in Safari */
  overflow-wrap: break-word; /* Fallback for other browsers */
  margin-left: 10px;
  max-width: 100%; 
  flex-shrink: 1;
  min-width: 0;
  line-height: normal;
  margin-bottom: 5px;
}
.notifications_unreadnotification__V1MX9 {
  /* background: rgb(108 168 225 / 10%); */
  background-color: #ecf4fc;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  box-shadow: 0px 3px 6px rgb(0 0 0 / 5%);
  border-radius: 25px;
  padding: 11px;
  margin: 10px 0px;
  justify-content: space-between;
}
.notifications_unreadnotificationdropdown__BimwP {
  background: transparent;
  outline: none !important;
  border: none !important;
  float: right;
}
.notifications_removenotifiction__VDEWZ {
  cursor: pointer;
}
.notifications_dropDownBtn__OjwRj {
  background-color: transparent;
  border-width: 0px;
  padding: 0px 10px;
  outline: none !important;
}
.notifications_noDataContainer__21r\\+N{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding-top: 100px;
  font-size: 20px;
  color: gray;
}
.notifications_followBtnContainer__WCfHH{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin: 15px 0 8px 0;
}
.notifications_followBtnContainer__WCfHH button {
  background-color: #3e90e1;
  border: none;
  border-radius: 20px;
  padding: 5px 20px;
  width: 50%;
  color: #ffffff;
  font-size: 14px;
  outline: none;
}
.notifications_AcceptRejectBtnContainer__R6lct{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin: 15px 0 8px 0;
  gap: 20px;
}
.notifications_AcceptRejectBtn__DfQhM{
  background-color: #3e90e1;
  border: none;
  border-radius: 20px;
  padding: 5px 10px;
  width: 30%;
  color: #ffffff;
  font-size: 14px;
  outline: none;
}`, "",{"version":3,"sources":["webpack://./src/Assets/css/notications/notifications.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,iCAAiC;EACjC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;;;;;;;;KASK;AACL;;EAEE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,QAAQ;AACV;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;EAChB,8BAA8B;AAChC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,yBAAyB;;EAEzB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,yBAAyB;;EAEzB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,2BAA2B;EAC3B,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,2BAA2B;EAC3B,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;AACA;;KAEK;AACL;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;EACvB,uBAAuB,EAAE,8CAA8C;EACvE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,gBAAgB,EAAE,6CAA6C;AACjE;AACA;EACE,uBAAuB,EAAE,8CAA8C;EACvE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,gBAAgB,EAAE,6CAA6C;AACjE;AACA;EACE,sBAAsB,EAAE,2BAA2B;EACnD,yBAAyB,EAAE,gCAAgC;EAC3D,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,wCAAwC;EACxC,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,uCAAuC;EACvC,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,8BAA8B;AAChC;AACA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,UAAU;EACV,cAAc;EACd,eAAe;EACf,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,SAAS;AACX;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,UAAU;EACV,cAAc;EACd,eAAe;EACf,aAAa;AACf","sourcesContent":[".notificationMainContainer {\r\n  /* width: 100%; */\r\n}\r\n\r\n.filterdropdown {\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n.filterdropdown h5 {\r\n  color: #000000;\r\n  font-size: 18px;\r\n  margin-top: 10px;\r\n  margin-left: 10px;\r\n}\r\n.selectpulldown {\r\n  border: none;\r\n  border-radius: 10px;\r\n  background-color: #f3f2f0;\r\n  font-size: 15px;\r\n  width: 125px;\r\n  height: 25px;\r\n  padding: 0px 10px;\r\n  margin: 10px 0 0 0;\r\n  box-shadow: 0px 3px 6px #00000029;\r\n  color: #000000;\r\n  cursor: pointer;\r\n}\r\n\r\n.selectpulldown option {\r\n  color: #373334;\r\n  font-size: 13px;\r\n  padding: 8px 13px;\r\n  font-weight: 300;\r\n  cursor: pointer;\r\n}\r\n\r\n/* .selectpulldown:after {\r\n    content: \" \";\r\n    width: 15px;\r\n    height: 15px;\r\n    position: absolute;\r\n    z-index: 11;\r\n    right: 10px;\r\n    top: 5px;\r\n    background: url(../../images/pulldown.svg) center no-repeat;\r\n  } */\r\n.recentTitle,\r\n.earlierTitle {\r\n  color: #373334;\r\n  font-size: 14px;\r\n  margin: 0 0 0 10px;\r\n}\r\n.notificationPost{\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: center;\r\n  align-items: flex-start;\r\n  gap: 5px;\r\n}\r\n.notificationbody {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: flex-start;\r\n  align-items: center;\r\n  background: #f3f2f0;\r\n  border-radius: 25px;\r\n  padding: 7px 12px 12px 15px;\r\n  margin: 10px 0px;\r\n  justify-content: space-between;\r\n}\r\n.notificationmessagebody > div > p {\r\n  margin-bottom: 0px;\r\n}\r\n.avatarimage {\r\n  margin: 9px 10px 0px 0px;\r\n}\r\n.loader {\r\n  position: absolute;\r\n  top: 40%;\r\n  left: 46%;\r\n}\r\n.tagcount {\r\n  position: relative;\r\n  left: 33px;\r\n  bottom: 7px;\r\n  background-color: #efba29;\r\n  width: 10px;\r\n  height: 10px;\r\n  color: white;\r\n  font-size: 10px;\r\n  border-radius: 50%;\r\n  padding: 0 0 0 4.4px;\r\n}\r\n.updatecount {\r\n  position: relative;\r\n  left: 33px;\r\n  bottom: 7px;\r\n  background-color: #e82727;\r\n  width: 10px;\r\n  height: 10px;\r\n  color: white;\r\n  font-size: 10px;\r\n  border-radius: 50%;\r\n  padding: 0 0 0 4.4px;\r\n}\r\n.saycount {\r\n  position: relative;\r\n  left: 33px;\r\n  bottom: 7px;\r\n  background-color: #45a735;\r\n\r\n  width: 10px;\r\n  height: 10px;\r\n  color: white;\r\n  font-size: 10px;\r\n  border-radius: 50%;\r\n  padding: 0 0 0 4.4px;\r\n}\r\n.askcount {\r\n  position: relative;\r\n  left: 33px;\r\n  bottom: 7px;\r\n  background-color: #2168b2;\r\n\r\n  width: 10px;\r\n  height: 10px;\r\n  color: white;\r\n  font-size: 10px;\r\n  border-radius: 50%;\r\n  padding: 0 0 0 4.4px;\r\n}\r\n.notificationdropdown {\r\n  outline: none !important;\r\n  background-color: transparent;\r\n  /* color: white !; */\r\n  /* padding: 16px; */\r\n  font-size: 16px;\r\n  border: none !important;\r\n  cursor: pointer;\r\n  /* background: lightgray; */\r\n  float: right;\r\n}\r\n.notificationdropdownlinks > ul {\r\n  margin-bottom: 0;\r\n  font-size: 14px;\r\n  list-style-type: none;\r\n  color: black;\r\n  padding: 5px 0px 0px 5px;\r\n}\r\n.notificationdropdownlinks {\r\n  border: none;\r\n  padding: 10px 10px 5px 10px;\r\n  min-width: 200px;\r\n  border-radius: 25px;\r\n  top: 20px;\r\n}\r\n.notificationdropdownlinks > ul > li > a > span {\r\n  padding-left: 7px;\r\n}\r\n.notificationdropdownlinks ul li {\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.earlierTitle {\r\n  margin-top: 20px;\r\n}\r\n/* .message{\r\n      font-size: 14px;\r\n  } */\r\n.messagetime {\r\n  font-size: 12px;\r\n  font-weight: 100;\r\n  margin-left: 10px;\r\n  color: rgba(0, 0, 0, 0.7);\r\n}\r\n.notificationmessagebody {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: flex-start;\r\n  align-items: flex-start;\r\n  overflow-wrap: anywhere; /* Allow breaking at any character if needed */\r\n  word-wrap: break-word;\r\n  white-space: normal;\r\n  flex-shrink: 1;\r\n  min-width: 0;\r\n  flex-basis: auto; /* Allow it to adjust size based on content */\r\n}\r\n.mesageandtime {\r\n  overflow-wrap: anywhere; /* Allow breaking at any character if needed */\r\n  word-wrap: break-word;\r\n  white-space: normal;\r\n  flex-shrink: 1;\r\n  min-width: 0;\r\n  flex-basis: auto; /* Allow it to adjust size based on content */\r\n}\r\n.msgTxt {\r\n  word-break: break-word; /* Works better in Safari */\r\n  overflow-wrap: break-word; /* Fallback for other browsers */\r\n  margin-left: 10px;\r\n  max-width: 100%; \r\n  flex-shrink: 1;\r\n  min-width: 0;\r\n  line-height: normal;\r\n  margin-bottom: 5px;\r\n}\r\n.unreadnotification {\r\n  /* background: rgb(108 168 225 / 10%); */\r\n  background-color: #ecf4fc;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: flex-start;\r\n  align-items: center;\r\n  box-shadow: 0px 3px 6px rgb(0 0 0 / 5%);\r\n  border-radius: 25px;\r\n  padding: 11px;\r\n  margin: 10px 0px;\r\n  justify-content: space-between;\r\n}\r\n.unreadnotificationdropdown {\r\n  background: transparent;\r\n  outline: none !important;\r\n  border: none !important;\r\n  float: right;\r\n}\r\n.removenotifiction {\r\n  cursor: pointer;\r\n}\r\n.dropDownBtn {\r\n  background-color: transparent;\r\n  border-width: 0px;\r\n  padding: 0px 10px;\r\n  outline: none !important;\r\n}\r\n.noDataContainer{\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: center;\r\n  align-items: center;\r\n  padding-top: 100px;\r\n  font-size: 20px;\r\n  color: gray;\r\n}\r\n.followBtnContainer{\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 100%;\r\n  margin: 15px 0 8px 0;\r\n}\r\n.followBtnContainer button {\r\n  background-color: #3e90e1;\r\n  border: none;\r\n  border-radius: 20px;\r\n  padding: 5px 20px;\r\n  width: 50%;\r\n  color: #ffffff;\r\n  font-size: 14px;\r\n  outline: none;\r\n}\r\n.AcceptRejectBtnContainer{\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 100%;\r\n  margin: 15px 0 8px 0;\r\n  gap: 20px;\r\n}\r\n.AcceptRejectBtn{\r\n  background-color: #3e90e1;\r\n  border: none;\r\n  border-radius: 20px;\r\n  padding: 5px 10px;\r\n  width: 30%;\r\n  color: #ffffff;\r\n  font-size: 14px;\r\n  outline: none;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"notificationMainContainer": `notifications_notificationMainContainer__W-Kto`,
	"filterdropdown": `notifications_filterdropdown__vR28z`,
	"selectpulldown": `notifications_selectpulldown__YoM9G`,
	"recentTitle": `notifications_recentTitle__7Bl3W`,
	"earlierTitle": `notifications_earlierTitle__TebVo`,
	"notificationPost": `notifications_notificationPost__23kgq`,
	"notificationbody": `notifications_notificationbody__RRsVT`,
	"notificationmessagebody": `notifications_notificationmessagebody__uJQsK`,
	"avatarimage": `notifications_avatarimage__dx0fw`,
	"loader": `notifications_loader__QRAQm`,
	"tagcount": `notifications_tagcount__0N2l-`,
	"updatecount": `notifications_updatecount__s4VXc`,
	"saycount": `notifications_saycount__1vELr`,
	"askcount": `notifications_askcount__8qPXG`,
	"notificationdropdown": `notifications_notificationdropdown__yDbu9`,
	"notificationdropdownlinks": `notifications_notificationdropdownlinks__Yyxxv`,
	"messagetime": `notifications_messagetime__n4SSJ`,
	"mesageandtime": `notifications_mesageandtime__nrgcK`,
	"msgTxt": `notifications_msgTxt__4kr0L`,
	"unreadnotification": `notifications_unreadnotification__V1MX9`,
	"unreadnotificationdropdown": `notifications_unreadnotificationdropdown__BimwP`,
	"removenotifiction": `notifications_removenotifiction__VDEWZ`,
	"dropDownBtn": `notifications_dropDownBtn__OjwRj`,
	"noDataContainer": `notifications_noDataContainer__21r+N`,
	"followBtnContainer": `notifications_followBtnContainer__WCfHH`,
	"AcceptRejectBtnContainer": `notifications_AcceptRejectBtnContainer__R6lct`,
	"AcceptRejectBtn": `notifications_AcceptRejectBtn__DfQhM`
};
export default ___CSS_LOADER_EXPORT___;
